import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-top-template",
  "use": "icon-top-template-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-top-template\"><defs><style>#icon-top-template .a{opacity:0;}#icon-top-template .b{fill:#666;}</style></defs><g transform=\"translate(16 16) rotate(-90)\"><rect class=\"a\" width=\"16\" height=\"16\" transform=\"translate(0 -16)\" /><path class=\"b\" d=\"M0,0H3.253L8.5-6.753l-5.393-6.58H0l5.313,6.58Z\" transform=\"translate(4.833 -1.333)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol